

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  ADD_RECORDING,
  CURRENT_RECORDING,
  CURRENT_POSITION,
  SET_CURRENT_RECORDING,
  SET_CURRENT_POSITION,
  UPDATE_RECORDING_DURATION
} from '@/store';

@Component
export default class AudioPlayback extends Vue {
  @Prop({ type: String }) url!: string;
  @Prop({ type: String }) id!: string;
  audio: HTMLAudioElement | null = null;
  audioDuration = 0;
  audioLoaded = false;
  playing = false;

  get currentPosition() {
    return this.$store.getters[CURRENT_POSITION];
  }

  beforeMount() {
    this.audio = new Audio(this.url);
    this.$store.commit(ADD_RECORDING, this.id);
    this.audio.addEventListener('loadeddata', this.dataLoaded);
    this.audio.addEventListener('timeupdate', this.timeUpdated);
    this.audio.addEventListener('ended', this.audioEnded);
  }

  dataLoaded() {
    if (this.audio && this.audio.readyState >= 2) {
      this.audioLoaded = true;
      this.audioDuration = this.audio.duration;
      this.$store.commit(UPDATE_RECORDING_DURATION, {
        id: this.id,
        duration: this.audioDuration
      });
    }
  }

  timeUpdated() {
    if (this.playing) {
      this.$store.commit(SET_CURRENT_POSITION, this.audio!.currentTime);
    }
  }

  audioEnded() {
    this.playing = false;
    this.audio!.currentTime = 0;
    this.$store.commit(SET_CURRENT_POSITION, 0);
  }

  play() {
    this.playing = true;
    this.$store.commit(SET_CURRENT_RECORDING, this.id);
    this.audio!.currentTime = this.currentPosition;
    this.audio!.play();
  }

  pause() {
    this.playing = false;
    if (this.audio) {
      this.audio.pause();
    }
  }

  beforeDestroy() {
    if (this.audio) {
      this.audio.removeEventListener('loadeddata', this.dataLoaded);
      this.audio.removeEventListener('timeupdated', this.timeUpdated);
      this.audio.removeEventListener('ended', this.audioEnded);
    }
  }

  @Watch('$store.state.audio.currentRecording')
  onCurrentRecordingChange(newId: string) {
    if (this.id !== newId) {
      this.pause();
    }
  }

  @Watch('$store.state.audio.requestedPosition')
  onRequestedPositionChange(newPosition: number) {
    if (this.playing) {
      this.audio!.currentTime = newPosition;
    }
  }
}
